// Cookie utility functions for handling AUTH_TOKEN cookie

/**
 * Get a cookie value by name
 * @param name - Cookie name
 * @returns Cookie value or null if not found
 */
export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    return match[2];
  }
  return null;
};

/**
 * Set a cookie with given name and value
 * @param name - Cookie name
 * @param value - Cookie value
 * @param expiresInSeconds - Expiration time in seconds (default: 3600 = 1 hour)
 * @param secure - Whether cookie should be secure (default: true)
 * @param sameSite - SameSite attribute (default: 'None')
 */
export const setCookie = (
  name: string,
  value: string,
  expiresInSeconds: number = 3600,
  secure: boolean = true,
  sameSite: string = 'None'
): void => {
  const expires = new Date(Date.now() + expiresInSeconds * 1000).toUTCString();
  let cookieString = `${name}=${value};expires=${expires};path=/`;
  
  if (secure) {
    cookieString += ';Secure';
  }
  
  if (sameSite) {
    cookieString += `;SameSite=${sameSite}`;
  }
  
  document.cookie = cookieString;
};

/**
 * Delete a cookie by name
 * @param name - Cookie name
 */
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Secure;SameSite=None`;
};

/**
 * Get the AUTH_TOKEN from cookie
 * @returns AUTH_TOKEN value or null
 */
export const getAuthTokenFromCookie = (): string | null => {
  return getCookie('AUTH_TOKEN');
};

/**
 * Check if AUTH_TOKEN cookie exists
 * @returns boolean
 */
export const hasAuthToken = (): boolean => {
  return !!getAuthTokenFromCookie();
};
